
const CommonConstant : any =  {
    localEnvironemt: "local",
};

export default CommonConstant;